import {
  Alert,
  AlertTitle,
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import { useMemo, useState } from 'react';
import Text from './Text';

const Dropdown = ({ label, items }) => {
  const [selected, setSelected] = useState(null);
  const selectedInfo = useMemo(
    () => items.find(item => item.option === selected),
    [selected, items]
  );

  return (
    <Box sx={{ my: 2 }}>
      <FormControl fullWidth>
        <InputLabel>{label}</InputLabel>
        <Select
          value={selected}
          label={label}
          onChange={e => setSelected(e.target.value)}
        >
          {items.map((item, index) => (
            <MenuItem value={item.option} key={index}>
              {item.option}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {selectedInfo && (
        <Alert
          sx={{ mt: 2, backgroundColor: '#E5F6FD', color: '#014361' }}
          icon={false}
          severity='info'
        >
          <AlertTitle>{selectedInfo.option}</AlertTitle>
          {selectedInfo.components.map((component, index) => (
            <Text {...component} key={index} />
          ))}
        </Alert>
      )}
    </Box>
  );
};

export default Dropdown;
